(() => {
  const root = document.getElementById('custom-bottle-root');
  if (!root) return;

  // Keep this outside /cart/add forms and omit AnyGift's identifying attribute.
  const controls = new WeakMap();
  const routeRoot = window.Shopify?.routes?.root || '/';
  let scheduled = false;

  function variantFor(form) {
    const id = form.querySelector('input[name="id"]')?.value;
    return window.product?.variants?.find(variant => String(variant.id) === String(id));
  }

  function available(variant) {
    return !!variant && (Number(variant.inventory_quantity) > 0 || variant.inventory_policy === 'continue');
  }

  function markPurchaseButtons() {
    // AnyGift prioritizes explicit submit buttons over standalone sold-out
    // buttons. Only normalize the theme's in-form buttons with implicit type.
    root.querySelectorAll('form[action*="/cart/add"] button[data-anygift="add-to-cart"]:not([type])').forEach(button => {
      button.setAttribute('type', 'submit');
    });
  }

  function scan() {
    markPurchaseButtons();
    // The theme also hides sold-out selectable-gift buttons. They have no
    // /cart/add form, so restore them separately from the purchase fallback.
    root.querySelectorAll('.disabled > button.txt[data-anygift="add-to-cart"]').forEach(button => {
      // AnyGift hides every marked button with display:none!important once
      // its UI mounts, including standalone sold-out indicators.
      if (button.style.display !== 'block') button.style.setProperty('display', 'block', 'important');
      if (button.style.opacity !== '1') button.style.opacity = '1';
      if (!button.disabled) button.disabled = true;
    });

    root.querySelectorAll('form[action*="/cart/add"] button[data-anygift="add-to-cart"], form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button:not([type])').forEach(original => {
      const form = original.closest('form');
      if (!form?.parentElement) return;
      let control = controls.get(original);
      const style = getComputedStyle(original);
      const formStyle = getComputedStyle(form);
      const hidden = style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0
        || formStyle.display === 'none' || formStyle.visibility === 'hidden' || Number(formStyle.opacity) === 0;
      const variant = variantFor(form);
      const soldOut = !!variant && !available(variant);
      const shouldShow = hidden && !!variant && (soldOut || !original.disabled);
      // Leave the original purchase UI entirely untouched unless a fallback is needed.
      if (!shouldShow) {
        if (control) {
          control.host.remove();
          controls.delete(original);
        }
        return;
      }
      if (!control) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = original.classList?.contains('button') ? 'button tiger-normal-purchase' : 'txt tiger-normal-purchase';
        button.textContent = soldOut ? (window.theme?.strings?.soldOut || '在庫なし') : '通常購入する';
        button.style.width = '100%';
        // Preserve the theme's minimum width so flex product cards don't collapse.
        button.style.minWidth = style.minWidth;
        button.style.maxWidth = '100%';
        button.style.boxSizing = 'border-box';
        const error = document.createElement('p');
        error.className = 'tiger-normal-purchase-error';
        error.setAttribute('role', 'alert');
        // Retain the original wrapper's button styles when moving above AnyGift.
        const host = document.createElement('div');
        host.className = form.parentElement.className;
        host.style.display = 'block';
        host.style.width = '100%';
        host.style.minWidth = style.minWidth;
        host.style.maxWidth = '100%';
        host.style.boxSizing = 'border-box';
        host.append(button, error);
        form.parentElement.insertBefore(host, form);
        control = { button, error, host, pending: false };
        controls.set(original, control);

        button.addEventListener('click', async () => {
          const variant = variantFor(form);
          if (control.pending || !available(variant)) return;
          control.pending = true;
          button.disabled = true;
          error.textContent = '';
          try {
            const response = await fetch(`${routeRoot}cart/add.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: String(variant.id), quantity: 1 }] }),
            });
            if (!response.ok) {
              const body = await response.json();
              throw new Error(body.description || body.message || 'カートに追加できませんでした。もう一度お試しください。');
            }
            // Match the theme's existing GA4 add-to-cart event.
            try { window.addToCart?.(variant.sku); } catch (trackingError) { console.warn(trackingError); }
            window.location.assign(`${routeRoot}cart`);
          } catch (purchaseError) {
            error.textContent = purchaseError.message || 'カートに追加できませんでした。もう一度お試しください。';
            control.pending = false;
            button.disabled = false;
          }
        });
      }
      const label = soldOut ? (window.theme?.strings?.soldOut || '在庫なし') : '通常購入する';
      if (control.button.textContent !== label) control.button.textContent = label;
      const disabled = soldOut || control.pending;
      if (control.button.disabled !== disabled) control.button.disabled = disabled;
      control.button.classList.toggle('disabled', disabled);
      // AnyGift can live outside the original form's wrapper. Find its actual
      // root within this product card, instead of assuming it is a form sibling.
      let scope = form.parentElement;
      let giftUi = null;
      while (scope && scope !== root) {
        giftUi = scope.querySelector('[data-anygift="ProductPageGiftUi"]');
        if (giftUi || scope.tagName === 'LI') break;
        scope = scope.parentElement;
      }
      if (giftUi) {
        let anchor = giftUi;
        // The normal button must remain outside any /cart/add form.
        while (anchor.closest('form') && anchor.parentElement) anchor = anchor.parentElement;
        if (anchor.previousElementSibling !== control.host) {
          anchor.parentElement.insertBefore(control.host, anchor);
        }
        if (control.host.style.marginBottom !== '16px') control.host.style.marginBottom = '16px';
      }
      if (control.button.style.minWidth !== style.minWidth) control.button.style.minWidth = style.minWidth;
      if (control.host.style.minWidth !== style.minWidth) control.host.style.minWidth = style.minWidth;
      if (control.button.style.display !== 'block') control.button.style.display = 'block';
    });
  }

  const observer = new MutationObserver(() => {
    // Do this before the deferred UI scan so AnyGift can find the form as
    // soon as React inserts its purchase buttons.
    markPurchaseButtons();
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  });
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'disabled', 'type'] });
  window.addEventListener('resize', scan);
  scan();
})();
